// src/pages/OrderList.js
import React, { useState, useEffect, Suspense } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import StatusFilter from "../components/StatusFilter";
import OrderDetailsModal from "../components/OrderDetailsModal";
import { useSelector } from "react-redux";
const OrderCard = React.lazy(() => import("../components/OrderCard"));

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState("all");
const [selectedOrder, setSelectedOrder] = useState(null);
  const user = useSelector((state) => state.auth.user); 
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${window.BASE_API_URL}orderlist/${user?.id}`);
        const data = await res.json();
        if (data.success) {
          setOrders(data.data || []);
          setFiltered(data.data || []);
        } else {
          toast.error("Failed to load orders");
        }
      } catch (error) {
        toast.error("Error fetching orders");
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const handleFilterChange = (status) => {
    setSelectedStatus(status);
    if (status === "all") {
      setFiltered(orders);
    } else {
      const filteredData = orders.filter((o) => String(o.status) === status);
      setFiltered(filteredData);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-green-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200 p-4 md:p-8">
      

      {/* ✅ Filter Bar */}
      {/* <StatusFilter selected={selectedStatus} onChange={handleFilterChange} /> */}

      {/* 🧾 Orders List */}
      {filtered.length === 0 ? (
        <div className="text-center text-gray-500 text-lg mt-12">
          No orders found.
        </div>
      ) : (
        <motion.div
          layout
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-6"
        >
          <Suspense fallback={<div>Loading...</div>}>
            <AnimatePresence>
              {filtered.map((order) => (
                <OrderCard key={order.id} order={order}  onOpen={setSelectedOrder} />
              ))}
            </AnimatePresence>
          </Suspense>
        </motion.div>
      )}

       {selectedOrder && (
        <OrderDetailsModal
          orderId={selectedOrder}
          onClose={() => setSelectedOrder(null)}
        />
      )}
    </div>
  );
};

export default OrderList;
